module.exports = __webpack_public_path__ + "img/car_4 - 副本.8440fc54.png";